// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__2gxt1","loaderOuter":"PageOverlayLoader_loaderOuter__3URqn"};